'use client';
import React from 'react';
import { MantineLogoRounded } from './MantineLogoRounded.mjs';
import { MantineLogoText } from './MantineLogoText.mjs';

function MantineLogo({ type, ...others }) {
  if (type === "mark") {
    return /* @__PURE__ */ React.createElement(MantineLogoRounded, { ...others });
  }
  return /* @__PURE__ */ React.createElement(MantineLogoText, { ...others });
}

export { MantineLogo };
//# sourceMappingURL=MantineLogo.mjs.map
